// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage  } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmK7gxQz_fVGaU0lXJUeIbUcyKojhZmWk",
  authDomain: "peertopeertutoring-f9842.firebaseapp.com",
  projectId: "peertopeertutoring-f9842",
  storageBucket: "peertopeertutoring-f9842.appspot.com",
  messagingSenderId: "1005543848414",
  appId: "1:1005543848414:web:9b9555d97f9c60e32f054f",
  measurementId: "G-6M6J18HNGG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const db = getFirestore();
const storage = getStorage();
const auth = getAuth();
const functions = getFunctions()

export {db};
export {storage}
export { auth }
export { functions }
// export { appCheck }
